import React, { useEffect, useState } from "react"
import { Link as GatsbyLink } from "gatsby"
import AnchorLink from "react-anchor-link-smooth-scroll"

const Link = ({
  title,
  children,
  button,
  to,
  activeClassName,
  activeStyle,
  partiallyActive,
  section_ref,
  target,
  track,
  offset,
  onClick,
  ...other
}) => {

  const [topOffset, setTopOffset] = useState(0);
  // GOOGLE TAG MANAGER TITLES
  const ConstructorName = (name) => {
    switch (name) {
      case "Layout":
        return "Menu"
      case "HomeHero":
        return "Hero"
      case "HeaderImage":
        return "Modal"
      case "FooterSimple":
        return "Footer"
      default:
        return name
    }
  }

  const internal = /^\/(?!\/)/.test(to)
  const scrollLink = /^(?!)/.test(to)
  useEffect(() => {
    if (scrollLink) {
      const id = to?.slice(1);
      console.log(id);
      var element = document.getElementById(id);
      var eleOffset = 0;
      if (element) {
        eleOffset = element?.offsetTop;
      }
      setTopOffset(eleOffset);
      console.log(to, eleOffset);
    }
  })

  if (section_ref) {
    return (
      <AnchorLink
        onClick={onClick}
        offset={topOffset}
        href={to}
        data-gtm={`${ConstructorName(track)} | ${title}`}
        title={title}
        // aria-label={`Link to ${title}`}
        {...other}>
        {children}
      </AnchorLink>
    )
  } else {

    if (internal) {
      if (target) {
        // console.log("INTERNAL_TARGET", to, topOffset);
        return (
          <a
            href={to}
            target={`${target}`}
            data-gtm={`${ConstructorName(track)} | ${title}`}
            title={title}
            // aria-label={`Link to ${title}`}
            {...other}>
            {children}
          </a>
        )
      } else {
        // console.log("INTERNAL_GATSBY", to, topOffset);
        return (
          <GatsbyLink
            to={to}
            activeClassName={activeClassName}
            activeStyle={activeStyle}
            partiallyActive={partiallyActive}
            data-gtm={`${ConstructorName(track)} | ${title}`}
            title={title}
            // aria-label={`Link to ${title}`}
            {...other}>
            {children}
          </GatsbyLink>
        )
      }
    }
    if (scrollLink) {
      // console.log("ANCHORLINK", to, topOffset);
      return (
        <AnchorLink
          onClick={onClick}
          offset={topOffset}
          href={to}
          data-gtm={`${ConstructorName(track)} | ${title}`}
          title={title}
          // aria-label={`Link to ${title}`}
          {...other}>
          {children}
        </AnchorLink>
      )
    }
    if (!to && !onClick) {
      return (
        <span title={title} {...other}>
          {children}
        </span>
      )
    }
    if (button) {
      // console.log("LINK_BUTTON", to, topOffset);
      return (
        <button title={title} onClick={onClick} {...other}>
          {children}
        </button>
      )
    }
  }

  // console.log("LINK_DEFAULT", to, topOffset);
  return (
    <>
      <a
        href={to}
        target={/W*httpW*/.test(to) ? "_blank" : ""}
        data-gtm={`${ConstructorName(track)} | ${title}`}
        rel="nofollow noopener noreferrer"
        title={title}
        onClick={onClick}
        // aria-label={`Link to ${title}`}
        {...other}>
        {children}
      </a>
    </>
  )
}

export default Link
